/*
  - Simple Use of Component - ngModel and sorterColumnName are required

    <nv-sorter-col-input
      ng-model="$ctrl.colValue"
      sorter-column-name="studentName"
      placeholder="placeholder" (OPTIONAL)
      input-type="dropdown" (OPTIONAL)
      items="$ctrl.studentNames" (OPTIONAL)
      ng-disabled="false" (OPTIONAL)
    >
    </nv-sorter-col-input>
*/

angular.module('nv.components.sorter-col-input').component('nvSorterColInput', {
  template: require('./sorter-col-input.html'),
  bindings: {
    ngModel: '=',
    sorterColumnName: '@',
    sorterColumnHuman: '@',
    onChange: '&?',
    // placeholder - optional
    placeholder: '@?',
    // inputType - optional - if present, overwrite default input type from SorterColumn.dataType
    inputType: '@?',
    // items - optional - items to be displayed in autocomplete or dropdown. Otherwise, defaults to
    // SorterColumn.dataTypeOptions.values if property exists on SorterColumn.
    items: '<?',
    ngDisabled: '<?',
  },
  controller: 'SorterColInputCtrl',
});
